<template>
  <gmap-map
    style="width: 100%; height: 24rem;"
    :zoom="6"
    :center="{ lat: -37.78, lng: 175.25 }"
    :options="{
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false
    }"
  >
    <Gmap-Marker
      v-for="(tracker, index) in this.trackers"
      :key="tracker.id"
      :position="{ lat: tracker.lat, lng: tracker.lng}"
      :options="{ fillColor: 'orange'}"
    ></Gmap-Marker>
  </gmap-map>
</template>

<script>
export default {
  name: 'TrackingMap',
  props: {
    trackers: {
      type: Array, required: true
    }
  },
  watch: {
    trackers() {
      console.log(this.trackers[0])
      console.log(this.trackers[0].lat)
    }
  }
}
</script>

<style scoped>

</style>
